"use client"

import { SelectProps, Skeleton } from "antd"
import { FC } from "react"

type SelectRoomAndPeopleSkeletonProps = Omit<SelectProps, 'size'> & {
  size?: 'small' | 'default'
}

const SelectRoomAndPeopleSkeleton: FC<SelectRoomAndPeopleSkeletonProps> = ({ size }) => {
  const isSmall = size == 'small'

  if (isSmall) {
    return (
      <div className="home__searching--field-control home__searching--field-control--stacked">
        <Skeleton paragraph={false} active styles={{ title: { height: '1.2rem', width: '8rem', margin: 0 } }} />
        <Skeleton paragraph={false} active styles={{ title: { height: '1.8rem', width: '100%', margin: '0.4rem 0 0' } }} />
      </div>
    )
  }

  return (
    <Skeleton.Button
      active
      block
      size="large"
    />
  )
}

export default SelectRoomAndPeopleSkeleton
